import { adminFileAuth } from './adminAuth';
import { employeeToken } from './employeeAuth';
import { supabase } from './supabaseClient';
import { recruitmentAdminAuth } from './recruitmentAccess';
import { validateResume } from './peopleWorkflow';
const setupError=error=>error.code==='PGRST202'||/function.*does not exist|schema cache/i.test(error.message||'');
export async function referralEmployee(employee,action,payload={},client=supabase){
  if(!employee?.id||!employee.session_token)throw new Error('Please sign in again before opening referrals.');
  const {data,error}=await client.rpc('recruitment_referral_employee',{p_employee_id:employee.id,p_pin:employeeToken(employee),p_action:action,p_payload:payload});
  if(error)throw new Error(setupError(error)?'Referrals are not available yet. Please contact HR.':error.message);
  return data;
}
export async function referralAdmin(company,action,payload={},client=supabase){
  const {data,error}=await client.rpc('recruitment_referral_admin',{...recruitmentAdminAuth(company),p_action:action,p_payload:payload});
  if(error)throw new Error(setupError(error)?'Referral setup is required. Run supabase/recruitment_requisitions_update.sql, then refresh.':error.message);
  return data;
}
export async function uploadReferralResume(employee,referralId,file){
  const problem=validateResume(file);if(problem)throw new Error(problem);
  const body=new FormData();body.append('file',file);body.append('auth',JSON.stringify({p_employee_id:employee.id,p_pin:employeeToken(employee)}));body.append('referral_id',referralId);
  const response=await fetch('/api/recruitment-resume',{method:'POST',body});
  const result=await response.json().catch(()=>({error:'Resume service is unavailable.'}));
  if(!response.ok)throw new Error(result.error||'Resume upload failed.');
  return result;
}
export async function openReferralResume(company,id){
  const preview=window.open('about:blank','_blank');if(preview)preview.opener=null;
  try{
    const response=await fetch('/api/recruitment-resume',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'download',auth:await adminFileAuth(company),referral_id:id})});
    if(!response.ok){const result=await response.json().catch(()=>({}));throw new Error(result.error||'Resume download failed.');}
    const blob=await response.blob(),url=URL.createObjectURL(blob);
    if(preview)preview.location.href=url;else{const link=document.createElement('a');link.href=url;link.download=decodeURIComponent(response.headers.get('X-Resume-Filename')||'resume.pdf');link.click();}
    setTimeout(()=>URL.revokeObjectURL(url),60000);
  }catch(error){preview?.close();throw error;}
}

export async function deleteRecruitmentResume(company,target){
  const response=await fetch('/api/recruitment-resume',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'delete_resume',auth:await adminFileAuth(company),...target})});
  const result=await response.json().catch(()=>({error:'Resume cleanup service is unavailable.'}));
  if(!response.ok)throw new Error(result.error||'Resume could not be deleted.');
  return result;
}
